<div class="form-group mr-2 mb-0">
  <div class="btn-group position-relative" dropdown>
    <button
      type="button"
      [popover]="popTemplate"
      [adaptivePosition]="false"
      [isOpen]="isOpen"
      placement="right"
      aria-haspopup="true"
      aria-expanded="false"
      triggers=""
      [title]="profileName"
      containerClass="customClass"
      #pop="bs-popover"
      dropdownToggle
      class="d-flex align-items-center btn btn-sm btn-outline-secondary dropdown-toggle"
    >
      <span class="text-truncate dropWidth">{{ profileName }}</span>
    </button>
    <div *ngIf="profileId$ | async as activeProfileId">
      <ul
        *dropdownMenu
        class="custom-menu scroll-size dropdown-menu"
        role="menu"
      >
        <h6 class="ml-1">Custom Profiles</h6>
        <div class="mr-2 ml-2" *ngIf="customProfiles.length === 0">
          <span style="font-size: small; white-space: nowrap">
            No custom profiles created yet.</span
          >
          <button
            class="btn btn-primary btn-sm"
            (click)="navigateToCreateProfile()"
          >
            Create Vehicle Routing Profile
          </button>
        </div>
        <li role="menuitem" *ngFor="let pf of customProfiles">
          <span
            class="dropdown-item small px-2 py-1"
            [ngClass]="{ active: pf.routingProfileId === activeProfileId }"
            (click)="changeProfile(pf)"
          >
            {{ pf.name }}
          </span>
        </li>
        <div class="dropdown-divider"></div>
        <li role="menuitem" *ngFor="let pf of defaultProfiles">
          <span
            class="dropdown-item small px-2 py-1"
            [ngClass]="{ active: pf.routingProfileId === activeProfileId }"
            (click)="changeProfile(pf)"
          >
            {{ pf.name }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</div>
<ng-template #popTemplate>
  <h5 class="text-gray-light">About Legacy Profile</h5>
  <p class="text-gray-light">
    This route is using
    <span class="font-weight-bold">{{ profileName }}</span> profile. To change
    the routing options select a different routing profile.
  </p>
  <div class="mt-1 d-flex justify-content-end">
    <button
      type="button"
      (click)="popOverClose()"
      class="btn btn-outline-dark text-gray-light border-gray-light"
    >
      Ok, Got it!
    </button>
  </div>
</ng-template>
